import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'inline-block',
      padding: theme.spacing(0, 0.25),
      margin: theme.spacing(0, -0.25),
      borderRadius: theme.shape.borderRadiusSmall,

      '&$highlighted': {
        boxShadow: `0 0 0 2px ${COLORS.primary.light}`,
      },
    },
    highlighted: {},
  }),
  { name: 'InstructionNode' }
);
